<template>
  <t-dialog :header="formData.id?'编辑':'添加'" v-model:visible="modelShow" :onConfirm="submitForm" :closeOnOverlayClick="false" width="600">
    <t-form :model="formData">
      <t-form-item label="模型文件">
        <t-upload
            :action="baseUrl+'/file/upload?dir=model'"
            v-model="modelPath"
            :format-response="formatModelResponse"
            :sizeLimit="modelSizeLimit"
            :headers="uploadHeaders"
            @success="handleModelSuccess"
            @remove="modelPath = null"
            draggable
            theme="file"
            tips="请上传GLTF模型"/>
      </t-form-item>
      <t-form-item label="模型缩略图">
        <t-upload
            :action="baseUrl+'/file/upload?dir=modelPic'"
            v-model="modelPic"
            :format-response="formatPicResponse"
            :sizeLimit="picSizeLimit"
            :headers="uploadHeaders"
            @success="handlePicSuccess"
            @remove="modelPic = null"
            theme="image"
            tips="请选择单张图片文件上传"
            accept="image/*"/>
      </t-form-item>
      <t-form-item label="模型名称">
        <t-input v-model="formData.modelName"/>
      </t-form-item>
    </t-form>
  </t-dialog>
</template>

<script>
import {saveOrUpdateApi} from "@/api/design-model";
import {getToken} from "@/utils/auth";
import {baseUrl,fileUrl} from "/env";

export default {
  name: "three-model-form",
  data() {
    return {
      fileUrl,
      uploadHeaders:{'X-Token':getToken()},
      baseUrl:baseUrl,
      formData: {},
      modelShow: false,
      modelSizeLimit:{size: 100, unit: 'MB', message: '模型大小不超过 {sizeLimit} MB'},
      picSizeLimit:{size: 2, unit: 'MB', message: '图片大小不超过 {sizeLimit} MB'},
      modelPath:[],
      modelPic:[]
    }
  },
  methods: {
    opened(isEdit, row) {
      this.formData = {};
      this.modelPath = [];
      this.modelPic = [];
      if(isEdit){
        this.formData = row
        this.modelPath.push({url:this.fileUrl + row.modelPath,response:{data:row.modelPath}})
        this.modelPic.push({url:this.fileUrl + row.modelPic,response:{data:row.modelPic}})
      }
      this.modelShow = true;
    },
    submitForm(){
      this.formData.modelPic = this.modelPic[0].response.data;
      this.formData.modelPath = this.modelPath[0].response.data;
      saveOrUpdateApi(this.formData).then(() => {
        this.$message.success('保存成功')
        this.modelShow = false;
        this.$emit('refreshTable');
      })
    },
    handleModelSuccess(res) {
      if (res.response.code !== 200){
        this.$message.error(res.msg)
      }else{
        this.formData.modelName = res.file.name.substr(0, res.file.name.lastIndexOf('.'));
      }
    },
    formatModelResponse(res){
      if (res.code !== 200) {
        return { error: '上传失败，请重试' };
      }
      return { ...res, url: this.fileUrl+res.data };
    },
    handlePicSuccess(res) {
      if (res.response.code !== 200){
        this.$message.error(res.msg)
      }
    },
    formatPicResponse(res){
      if (res.code !== 200) {
        return { error: '上传失败，请重试' };
      }
      return { ...res, url: this.fileUrl+res.data };
    },
  }
}
</script>

<style scoped>

</style>
